export default __webpack_public_path__ + "static/media/fundiario-agrario.2bbd6a56.jpg";